// import React, { memo, useState, useRef, useEffect } from "react";
// import classes from "./Sidebar.module.css";
// import { Link, useNavigate } from "react-router-dom";
// import { ChevronRight } from "@mui/icons-material";

// const SideBarTab = ({
//   roles,
//   tabName,
//   active,
//   clickFunc,
//   subOptions,
//   navigatePath,
//   icon,
//   activeIcon,
//   collapsed,
//   disabled = false,
// }) => {
//   const [isDropdownOpen, setDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const [isSubOptionClicked, setSubOptionClicked] = useState(false);
//   const navigate = useNavigate();
//   const handleTabClick = () => {

//     if (disabled) return;

//     if (subOptions) {
//       setDropdownOpen((prev) => !prev);
//     } else {
//       clickFunc?.();
//       if (navigatePath) {
//         navigate(navigatePath);
//       }
//     }
//   };

//   useEffect(() => {
//     if (isSubOptionClicked) {
//       clickFunc?.();
//     }
//   }, [isSubOptionClicked]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const tabClasses = `
//     ${classes.sidebar_tab} 
//     ${active ? classes.sidebar_tab_active : ""} 
//     ${disabled ? classes.disabled_tab : ""}
//   `;

//   return (
//     <div className={`${classes.sidebar_tab_wrapper}`} ref={dropdownRef}>
//       {!subOptions ? (
//         <Link
//           to={navigatePath}
//           className={`${classes.sidebar_tab} 
//           ${active && classes.sidebar_tab_active}`}
//           onClick={clickFunc}
//         >
//           <div className={classes.tab_icon}>
//             <span className={classes.icon_background}>
//               {active ? activeIcon : icon}
//             </span>
//           </div>
//           {!collapsed && <span className={classes.tab_name}>{tabName}</span>}
//         </Link>
//       ) : (
//         <div
//           className={`${classes.sidebar_tab} 
//           ${active && classes.sidebar_tab_active}`}
//           onClick={handleTabClick}
//         >
//           <div className={classes.tab_icon}>
//             {" "}
//             <span className={classes.icon_background}>
//               {active ? activeIcon : icon}
//             </span>
//           </div>
//           {!collapsed && (
//             <>
//               <span className={classes.tab_name}>{tabName}</span>
//               <ChevronRight
//                 className={`${classes.dropdown_icon} ${isDropdownOpen ? classes.dropdown_icon_open : ""
//                   }`}
//               />
//             </>
//           )}
//         </div>
//       )}

//       {subOptions && isDropdownOpen && !collapsed && (
//         <div className={`${classes.dropdown_menu}`}>
//           {subOptions.map((option, subIndex) => (
//             <Link
//               key={subIndex}
//               to={option.path}
//               className={`${classes.dropdown_item} ${option.disabled ? classes.disabled_tab : ""
//                 }`}
//               onClick={() => {
//                 if (!option.disabled) {
//                   navigate(option.path);
//                   setSubOptionClicked(true);
//                 }
//               }}
//             >
//               {option.icon && (
//                 <span className={classes.icon_background}>{option.icon}</span>
//               )}
//               <span className={classes.dropdown_item_text}>{option.title}</span>
//             </Link>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default memo(SideBarTab);


import React, { memo, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronRight } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import classes from "./Sidebar.module.css";

const SideBarTab = ({
  roles,
  tabName,
  active,
  clickFunc,
  subOptions,
  navigatePath,
  icon,
  activeIcon,
  collapsed,
  disabled = false,
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isSubOptionClicked, setSubOptionClicked] = useState(false);
  const navigate = useNavigate();

  const handleTabClick = () => {
    if (disabled) return;

    if (subOptions) {
      setDropdownOpen((prev) => !prev);
    } else {
      clickFunc?.();
    }
  };

  useEffect(() => {
    if (isSubOptionClicked) {
      clickFunc?.();
    }
  }, [isSubOptionClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const tabClass = `
    ${classes.sidebar_tab} 
    ${active ? classes.sidebar_tab_active : ""} 
    ${disabled ? classes.disabled_tab : ""}
  `;

  const renderCollapsedTooltip = (children) => (
    <Tooltip
      arrow
      placement="right"
      title={collapsed ? tabName : ""}
      disableHoverListener={!collapsed}
      disableFocusListener={!collapsed}
      disableTouchListener={!collapsed}
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "13px",
            fontFamily: "gilroyMedium",
          },
        },
      }}
    >
      <div className={classes.sidebar_tooltip_wrapper}>{children}</div>
    </Tooltip>
  );

  return (
    <div className={classes.sidebar_tab_wrapper} ref={dropdownRef}>
      {/* Single Level Item */}
      {!subOptions ? (
        renderCollapsedTooltip(
          <Link
            to={disabled ? "#" : navigatePath}
            onClick={(e) => {
              if (disabled) {
                e.preventDefault();
                return;
              }
              clickFunc?.();
            }}
            className={tabClass}
          >
            <div className={classes.tab_icon}>
              <span className={classes.icon_background}>
                {active ? activeIcon : icon}
              </span>
            </div>

            {!collapsed && <span className={classes.tab_name}>{tabName}</span>}
          </Link>
        )
      ) : (
        // Dropdown Wrapper
        renderCollapsedTooltip(
          <div className={tabClass} onClick={handleTabClick}>
            <div className={classes.tab_icon}>
              <span className={classes.icon_background}>
                {active ? activeIcon : icon}
              </span>
            </div>
            {!collapsed && (
              <>
                <span className={classes.tab_name}>{tabName}</span>
                <ChevronRight
                  className={`${classes.dropdown_icon} ${
                    isDropdownOpen ? classes.dropdown_icon_open : ""
                  }`}
                />
              </>
            )}
          </div>
        )
      )}

      {/* Suboptions (Dropdown) */}
      {subOptions && isDropdownOpen && !collapsed && (
        <div className={classes.dropdown_menu}>
          {subOptions.map((option, subIndex) => (
            <Link
              key={subIndex}
              to={option.disabled ? "#" : option.path}
              className={`${classes.dropdown_item} ${
                option.disabled ? classes.disabled_tab : ""
              }`}
              onClick={(e) => {
                if (option.disabled) {
                  e.preventDefault();
                  return;
                }
                
                // Check for advanced onboarding features for demo user
                const isAdvancedOnboarding = option.title === "Advanced Onboarding" || 
                                           option.title === "Supplier Compliance Verification";
                
                if (isAdvancedOnboarding && option.isDemoUser) {
                  e.preventDefault();
                  option.onSubscriptionClick?.();
                  return;
                }
                
                setSubOptionClicked(true);
                navigate(option.path);
              }}
            >
              {option.icon && (
                <span className={classes.icon_background}>{option.icon}</span>
              )}
              <span className={classes.dropdown_item_text}>{option.title}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(SideBarTab);
